import { ReactElement, useMemo, useState } from 'react';
import { GetOverviewSummary } from '../types';
import { useTranslation } from 'react-i18next';
import { AvailabilityDescriptionTooltipContent } from './styles';
import { BigNumberCard } from './components/Card';
import { normalizeNumber } from '../helpers/numbers';
import { colors } from '~/styles/colors';
import { useHistory } from 'react-router-dom';
import { useFilterContext } from '../contexts/FilterContext';
import { handleFilterStateRoute } from '../helpers/filters';
import { getUserProfile } from '~/helpers/userProfile';

interface UnitsProps {
  data: GetOverviewSummary['DISPONIBILITY'] | undefined;
  loading: boolean;
}

export function UnitsDisponibility({
  data,
  loading,
}: Readonly<UnitsProps>): ReactElement {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedOptions, client } = useFilterContext();
  const [profile] = useState(getUserProfile());

  function indicatorColor(): string {
    const disponibility = data?.HIGH_PERCENTAGE_DISPONIBILITY;
    if (!disponibility) return colors.icon['disabled-300'];

    if (disponibility >= 90) return colors.state.success.base;
    if (disponibility > 70) return colors.state.warning.base;
    return colors.state.danger.base;
  }

  const hasPredictiveAccess = useMemo(() => {
    const ALLOWED_PREDICTIVE_CLIENT_IDS = new Set([145]);

    return profile.permissions.PER_CLIENT.some(
      (item) => ALLOWED_PREDICTIVE_CLIENT_IDS.has(item.clientId),
    );
  }, [profile.permissions.PER_CLIENT]);

  function onClickDisponibiltyDetails(): void {
    if (hasPredictiveAccess) {
      history.push('/analise/conectividade',
        handleFilterStateRoute(client, selectedOptions, profile));
    }
  }

  return (
    <BigNumberCard
      id="disponibility"
      icon="WifiOnIcon"
      number={`${normalizeNumber(data?.HIGH_PERCENTAGE_DISPONIBILITY)}%`}
      description={{
        text: t('unidadesComAltaDisponibilidade'),
        tooltip: <DisponibilityTooltip />,
      }}
      subDescription={{
        number: normalizeNumber(data?.TOTAL_HIGHER_DISPONIBILITY_UNITS),
        text: t('unidadesComBoaDisponibilidadeDosDados'),
      }}
      loading={loading}
      disabledTooltip={loading || !data}
      indicatorColor={indicatorColor()}
      dataTestId="big-number-card-unit-disponibility"
      onClickDetails={hasPredictiveAccess ? onClickDisponibiltyDetails : undefined}
    />
  );
}

function DisponibilityTooltip(): ReactElement {
  const { t } = useTranslation();

  return (
    <AvailabilityDescriptionTooltipContent>
      <span>{t('altaDisponibilidadeDescricao')}</span>
    </AvailabilityDescriptionTooltipContent>
  );
}
